import { omit } from "lodash";
import {
  ApplicationCompanyInfo,
  ApplicationCompanyInfo as CompanyInfo,
} from "../../features/api-interfaces";
import { isAllValuesNull } from "../../utils/common";
import { APPLICATION_CONTENT, ApplicationContentKey } from "./constants";

/**
 * 現情報と申請情報で差分がある項目を抽出する.
 * @param {CompanyInfo | undefined} officialCompany 現情報
 * @param {CompanyInfo | undefined} applicationCompany 申請情報
 * @param {boolean} isDocomoStaffUser ドコモユーザ（営業管理、管理者、業務担当）
 * @returns 各々の差分項目が格納されたオブジェクト
 */
export const getDiffCompanyInfo = (
  officialCompany: CompanyInfo | undefined,
  applicationCompany: CompanyInfo | undefined,
  isDocomoStaffUser: boolean
): {
  diffOfficialCompany: Record<ApplicationContentKey, string>;
  diffApplicationCompany: Record<ApplicationContentKey, string>;
} => {
  const diffOfficialCompany: Record<ApplicationContentKey, string> =
    {} as Record<ApplicationContentKey, string>;
  const diffApplicationCompany: Record<ApplicationContentKey, string> =
    {} as Record<ApplicationContentKey, string>;

  if (isAllValuesNull(officialCompany) || isAllValuesNull(applicationCompany))
    return { diffOfficialCompany, diffApplicationCompany };

  // 表示制御するために権限によって比較対象を決定する
  const filterAppContent = isDocomoStaffUser
    ? APPLICATION_CONTENT
    : omit(APPLICATION_CONTENT, "settlementFeeRate");

  for (const key of Object.keys(filterAppContent) as Array<
    keyof ApplicationCompanyInfo
  >) {
    const officialValue = (officialCompany![key] as string) || "";
    const applicationValue = (applicationCompany![key] as string) || "";

    // 申請情報に値があるうち、現情報と差分があれば各オブジェクトに格納する
    if (applicationValue.length !== 0 && officialValue !== applicationValue) {
      diffOfficialCompany[key as ApplicationContentKey] = officialValue;
      diffApplicationCompany[key as ApplicationContentKey] = applicationValue;
    }
  }

  return { diffOfficialCompany, diffApplicationCompany };
};
